import React from "react";

import CloseIcon from '@mui/icons-material/Close'; 
import Iconify from '../../../../components/Iconify'; 
import { Dialog, DialogContent, DialogTitle, Box,  TextField, IconButton, Button} from '@mui/material';
import HTTPManager from "../../../../utils/httpRequestManager";
import Spinner from '../../../../components/Spinner';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;
export default class AssignComponent extends React.Component{
    httpManager = new HTTPManager();
    constructor(props){
        super(props); 
        this.state = {
            isLoading: false,
            searchText: '',
            allUsers:[],
            filteredUsers:[]
        }
        this.reloadData = this.reloadData.bind(this);
        this.searchData = this.searchData.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    componentDidMount(){
        this.reloadData();
    }

    reloadData(){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`/merchant/getAllUsers`,{userType: this.props.selectedUserTypeKey}).then(response=>{
                this.setState({allUsers: response.data, filteredUsers: response.data, isLoading:false})
            })
        })
    }

    searchData(){
        if(this.state.searchText !== ''){
            var filteredRecords = this.state.allUsers.filter(item=>{//console.log(item); 
                return (item.firstName.toLowerCase().indexOf(this.state.searchText.toLowerCase()) !== -1 || 
            item.lastName.toLowerCase().indexOf(this.state.searchText.toLowerCase()) !== -1 || item.email.toLowerCase().indexOf(this.state.searchText.toLowerCase()) !== -1)});
            //console.log("FILTERED",filteredRecords)
            this.setState({filteredUsers: filteredRecords})
        }
        else{
            this.setState({filteredUsers: this.state.allUsers});
        }
    }

    clearSearch(){
        this.setState({searchText:'', filteredUsers: this.state.allUsers});
    }

    render(){
        return <Dialog
        open={true}
        style={{width: '100%',height: '100%',top: '50%',left: '50%',transform: 'translate(-50%, -50%)',}}
        title= 'Loading'
        disablePortal={false}
        onClose={this.props.onClose}
        PaperProps={{
            style: {
                width:'500px',
                height:'500px'
            },
        }}
    >
        <DialogTitle>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <p>Select {this.props.selectedUserType}</p>
                <div onClick={()=>this.props.onClose()}> <CloseIcon/></div>
            </div>
        </DialogTitle>
        <DialogContent style={{background: '#ffffff'}}>
            {this.state.isLoading && <Spinner />}
            {!this.state.isLoading &&   <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 0 }}>
          <Box sx={{ flexGrow: 1 }}>
                <div style={{width:'100%', display:'flex'}}>
                    <TextField
                    fullWidth
                    variant="outlined"
                    value={this.state.searchText}
                    onChange={(e)=>{
                        this.setState({searchText: e.target.value},()=>{
                            this.searchData();
                        })
                    }}
                    placeholder=" Search…" 
                    InputProps={{
                    startAdornment:  getIcon('mdi:search-fill'),
                    endAdornment: (
                        <IconButton
                        title="Clear"
                        aria-label="Clear"
                        size="medium"
                        style={{ visibility: this.state.searchText !== '' ? 'visible' : 'hidden' }}
                        onClick={()=>this.clearSearch()}
                        >
                        {getIcon("mdi:close")}
                        </IconButton>
                    )
                    }} 
                    /> 
                </div>
                <div contentEditable={false} style={{width:'100%', height:'350px', overflow:'auto', display:'flex',flexDirection:'column', marginTop:'1rem'}}>
                    {this.state.filteredUsers.length > 0 &&<>
                        {this.state.filteredUsers.map(el=>{
                            return <><div  contentEditable={false}  onClick={(e)=>{
                                //console.log(el)
                                this.props.onAssign(el)
                                e.preventDefault();
                            }} style={{cursor:'pointer', borderBottom:'1px solid #f0f0f0', padding:"1rem 0",display:'flex',width:'100%',  alignItems:'start', justifyContent:'space-between',flexDirection:'row', fontSize:'16px', fontWeight:'500'}}>
                                <div>
                                    <p>{el.firstName+" "+el.lastName}</p> 
                                    <p style={{fontSize:'14px', color:'#999'}}>{el.email}</p>
                                </div>
                                <div>
                                    <Button variant="contained" onClick={(e)=>{
                                //console.log(el)
                                        this.props.onAssign(el)
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}>Select</Button>
                                </div>
                            </div>
                            </>
                        })}
                    </>}
                    {this.state.filteredUsers.length === 0 &&<div style={{display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:'13px', fontWeight:'500'}}>
                        No records found.
                        </div>
                    }

                </div>

          </Box>
          </Box>}

        </DialogContent>
    </Dialog>
    }
}